<template>
  <layout name="Notification">
    <VSystemMessage primaryText="" size="small">
      <div class="reset-password">
        <div class="reset-password__primary-text">
          <img :src="successfullyImg" /><span>You're all set!</span>
        </div>
        <p class="reset-password__footer">
          Return to the
          <v-link type="primary" routerLink="/login" label="Login Page" inverted />
          to sign in with your shiny new password.
        </p>
      </div>
    </VSystemMessage>
  </layout>
</template>

<script>
import Vue from "vue";
import Layout from "@/layouts/Layout";
import VLink from "@/components/VLink";
import VSystemMessage from "@/components/VSystemMessage";

//assets
import successfullyImg from "@/assets/images/successfully.svg";

export default Vue.component("ResetPasswordInitSuccess", {
  metaInfo: {
    title: "Reset Password Finish"
  },

  components: {
    Layout,
    VLink,
    VSystemMessage
  },

  data() {
    return {
      successfullyImg
    };
  }
});
</script>

<style lang="scss" scoped>
$ns: "reset-password";

.#{$ns}{
  margin-top: 35px;
  width: 85%;
}

.#{$ns}__primary-text {
  font-size: 24px;
  color: $primary-color;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 67px;

  img {
    margin-right: 20px;
  }
}

.#{$ns}__footer {
  font-size: 16px;
  font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
  line-height: 1.5;
  color: $primary-text-color;
}
</style>
